module.exports = __webpack_public_path__ + "c71c333e15783dbafe1f85032d8437d0.png";